<template>
    <div class="ypglBody">
        <el-row :gutter="20">
            <el-col :span="2.5">
                <el-input style="width: 200px;" v-model="showCategoryStr" size="mini" placeholder="请输入添加分类"></el-input>
            </el-col>
            <el-col :span="2.5">
                <el-button type="primary" icon="el-icon-plus" size="mini" @click="categoryAddStrFun">添加</el-button>
            </el-col>
            <el-col :span="2.5">
                <el-button icon="el-icon-edit" size="mini" @click="categoryEditStrFun">编辑</el-button>
            </el-col>
            <el-col :span="2.5">
                <el-button type="danger" icon="el-icon-delete" size="mini" @click="categoryDelStrFun">删除</el-button>
            </el-col>
        </el-row>
        <el-container class="ypglMain">
            <el-aside width="200px" class="asidsStyle">
                <div class="radioBox">
                    <el-radio class="radioStyle" v-for="item in classListData" :key="item.id" v-model="radioValue"
                        :label="item.id" border @input="radioValueFun">{{ item.category_name }}</el-radio>
                </div>
            </el-aside>
            <el-main class="elMainStyle">
                <el-row :gutter="20">
                    <el-col :span="2.5">
                        <el-button type="success" icon="el-icon-plus" size="mini" @click="drugListAddFun">添加</el-button>
                    </el-col>
                </el-row>
                <el-table :data="drugsListData" style="width: 100%;margin-top: 10px;">
                    <el-table-column prop="created_at" label="创建时间" align="center" />
                    <el-table-column prop="number" label="编号" align="center" />
                    <el-table-column prop="title" label="药名" align="center" />
                    <el-table-column prop="price" label="价格" align="center" />
                    <el-table-column prop="category_name" label="分类名称" align="center" />
                    <el-table-column label="图片" align="center">
                        <template slot-scope="scope">
                            <el-tag class="cursor" size="medium" @click="showDetailsFun(scope.row.logo)">
                                <i class="el-icon-view"></i>
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center">
                        <template slot-scope="scope">
                            <el-tag class="cursor" size="medium" @click="editDetailsFun(scope.row)">
                                编辑
                            </el-tag>
                            <el-tag class="cursor" size="medium" @click="DelDetailsFun(scope.row)">
                                删除
                            </el-tag>
                        </template>
                    </el-table-column>
                </el-table>
            </el-main>
        </el-container>

        <!-- 分类编辑 -->
        <el-dialog title="分类编辑" :visible.sync="showEdit" width="30%" style="margin-top: 20vh;">
            <el-row :gutter="20">
                <el-col>
                    <span>分类名称：</span>
                    <el-input style="width: 80%;" v-model="showEditStr.category_name"></el-input>
                </el-col>
            </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showEdit = false">取 消</el-button>
                <el-button type="primary" @click="BtnEditStrFun">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 图片详情 -->
        <el-dialog title="药品图" :visible.sync="showImg" width="60%">
            <el-image style="width: 100%; height: 100%" :src="logoImgUrl">
            </el-image>
        </el-dialog>
        <!-- 添加药品 -->
        <el-dialog :title="drugtitle" :visible.sync="showdrugListAdd" width="50%" :before-close="showdrugListAddFun">
            <el-form class="drugListAddFromStyle" ref="form" :model="drugListAddFrom" label-width="100px">
                <el-form-item label="药品名：">
                    <!-- <el-input v-model="drugListAddFrom.info_title" placeholder="请输入药品名"></el-input> -->
                    <el-select :disabled="editAndAdd == false" style="width: 100%;" v-model="info_title" filterable remote
                        reserve-keyword placeholder="请输入关键词" :remote-method="remoteMethod" :loading="drugoptionsloading"
                        @change="drugChange">
                        <el-option v-for="item in drugoptions" :key="item.title" :label="item.title" :value="item.title">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="药品编号：">
                    <el-input :disabled="editAndAdd == false" v-model="drugListAddFrom.number"
                        placeholder="请输入药品编号"></el-input>
                </el-form-item>
                <el-form-item label="药品剂型：">
                    <el-input :disabled="editAndAdd == false" v-model="drugListAddFrom.drugs_dosage_form"
                        placeholder="请输入药品剂型  如：片"></el-input>
                </el-form-item>
                <el-form-item label="药品规格：">
                    <el-input :disabled="editAndAdd == false" v-model="drugListAddFrom.drugs_specs"
                        placeholder="请输入药品规格  如：100g/袋"></el-input>
                </el-form-item>

                <el-form-item label="药品logo：">
                    <el-upload class="avatar-uploader" multiple action="/api/Upload/up" :show-file-list="false"
                        :on-success="handleAvatarSuccess" name="image[]" :headers="headersObj">
                        <img v-if="drugListAddFrom.logo" :src="drugListAddFrom.logo" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="药品详情页：">
                    <el-upload class="upload-demo" action="/api/Upload/up" multiple :file-list="fileList"
                        list-type="picture" :on-success="fileListSuccess" name="image[]" :on-remove="fileremove">
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>

                </el-form-item>
                <el-form-item label="药品说明：">
                    <el-input type="textarea" @input="InputEvent" v-model="drug_description"></el-input>
                </el-form-item>
                <el-form-item label="药品详情：" class="titleStyle">
                    <div class="detailBox">
                        <div class="detailBox_left">
                            <div style="margin-bottom: 10px;" v-for="(item, index) in JsonData" :key="index">
                                <el-input class="inputStyle1" v-model="item.key" placeholder="标题 如：不良反应" />
                                <el-input class="inputStyle2" v-model="item.value" placeholder="说明 如：腹泻" />
                                <el-tag type="danger" @click="DelJsonData(index)">
                                    <i class="el-icon-minus"></i>
                                </el-tag>
                            </div>
                        </div>
                        <div class="detailBox_right">
                            <el-tag type="success" @click="addJsonData">
                                <i class="el-icon-plus"></i>
                            </el-tag>
                        </div>
                    </div>
                </el-form-item>
            </el-form>
            <div style="text-align: end; padding-right: 20px;">
                <el-button @click="showdrugListAddFun">取 消</el-button>
                <el-button type="primary" @click="drugListAddBtnFun">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { categoryList, categoryAdd, categoryDel, categoryEdit, drugsList, drugListAdd, Drugslist, drugListDel, drugListEdit, Upload } from '../../api/ypgl';
export default {
    data() {
        return {
            classListFrom: {
                page: '1',
                limit: '10'
            },
            classListData: [],
            radioValue: '',
            showCategoryStr: '',
            showEdit: false,
            showEditStr: {},
            drugsListFrom: {
                page: '',
                limit: '',
                category_id: null,
                number: ''
            },
            drugsListData: [],
            showImg: false,
            logoImgUrl: '',
            showdrugListAdd: false,
            drugListAddFrom: {
                logo: '',
                banner: ''
            },
            JsonData: [
                { key: '', value: '' },
            ],
            drugoptions: [],
            drugoptionsloading: false,
            info_title: '',
            drugtitle: '',
            editAndAdd: false,
            filename: '',
            headersObj: {
                token: localStorage.getItem('logintoken')
            },
            fileList: [],
            drug_description: ''
        }
    },
    created() {
        this.classList()
    },
    methods: {
        // 请求分类
        classList() {
            categoryList(this.classListFrom).then(res => {
                this.classListData = res.data
                if (this.radioValue == '') this.radioValue = res.data[0].id
                this.drugsListFrom.category_id = this.radioValue
                this.drugListAddFrom.category_id = this.radioValue
                this.radioValueFun(this.radioValue)
            })
        },
        // 添加分类
        categoryAddStrFun() {
            const that = this
            if (this.showCategoryStr == '') {
                return this.$message({
                    type: 'info',
                    message: '请输入分类名称！'
                });
            }
            this.$confirm(`是否添加 ${that.showCategoryStr} 的分类`, '添加分类', {
                distinguishCancelAndClose: true,
                confirmButtonText: '保存',
                cancelButtonText: '取消'
            }).then(() => {
                categoryAdd({ category_name: that.showCategoryStr }).then(res => {
                    that.$message({
                        type: 'success',
                        message: res.msg
                    });
                    that.classList()
                    that.showCategoryStr = ''
                })
            }).catch(action => {
                that.showCategoryStr = ''
            });
        },
        // 删除分类
        categoryDelStrFun() {
            const that = this
            let str = ''
            this.classListData.forEach(item => {
                if (item.id == this.radioValue) {
                    str = item.category_name
                }
            });
            this.$confirm(`是否删除 ${str} 的分类`, '删除分类', {
                distinguishCancelAndClose: true,
                confirmButtonText: '保存',
                cancelButtonText: '放弃修改'
            }).then(() => {
                categoryDel({ id: that.radioValue }).then(res => {
                    that.$message({
                        type: 'success',
                        message: res.msg
                    });
                    this.radioValue = this.classListData[1].id
                    that.classList()
                })
            }).catch(action => {
                this.$message({
                    type: 'info',
                    message: `您已放弃删除${str}`
                })
            });
        },
        // 弹框编辑
        categoryEditStrFun() {
            this.showEdit = true
            let obj = null
            this.classListData.forEach(item => {
                if (item.id == this.radioValue) {
                    obj = { ...item }
                }
            });
            this.showEditStr = obj
        },
        // 编辑提交
        BtnEditStrFun() {
            categoryEdit(this.showEditStr).then(res => {
                this.showEdit = false
                this.$message({
                    type: 'success',
                    message: res.msg
                });
                this.classList()
            })
        },
        // 选择分类
        radioValueFun(e) {
            this.drugsListFrom.category_id = String(e)
            this.drugListAddFrom.category_id = String(e)
            drugsList(this.drugsListFrom).then(res => {
                this.drugsListData = res.data
            })
        },
        // 显示图片
        showDetailsFun(e) {
            this.showImg = true
            this.logoImgUrl = e
        },
        // 药品添加按钮
        drugListAddFun() {
            this.editAndAdd = true
            this.drugtitle = '添加药品'
            this.showdrugListAdd = true
        },
        // 药品添加详情加一条
        addJsonData() {
            this.JsonData.push({
                key: '',
                value: ''
            })
        },
        // 药品添加提交
        drugListAddBtnFun() {
            let a = {}
            let list = this.JsonData
            for (const key in list) {
                a[list[key].key] = list[key].value
            }
            this.drugListAddFrom.detail = JSON.stringify(a)
            if (this.editAndAdd == true) {
                drugListAdd(this.drugListAddFrom).then(res => {
                    this.$message({
                        type: 'success',
                        message: res.msg
                    });
                    this.fileList = []
                    this.classList()
                    this.showdrugListAdd = false
                })
            } else {
                drugListEdit(this.drugListAddFrom).then(res => {
                    this.$message({
                        type: 'success',
                        message: res.msg
                    });
                    this.fileList = []
                    this.classList()
                    this.showdrugListAdd = false
                })
            }
            this.drug_description = ''
            this.fileList = []
        },
        // 药品添加详情存在一条
        DelJsonData(ind) {
            if (this.JsonData.length == 1) return this.$message({
                type: 'warning',
                message: '确保有一条哦！'
            });
            this.JsonData.splice(ind, 1)
        },
        // 图片上传成功
        handleAvatarSuccess(e) {
            this.$message({
                type: 'success',
                message: 'logo图片上传成功!'
            });
            this.drugListAddFrom.logo = e.data[0]
        },
        // 联动搜索
        remoteMethod() {
            this.drugoptionsloading = true
            let obj = {
                title: this.info_title,
                page: '1',
                limit: '20',
            }
            Drugslist(obj).then(res => {
                this.drugoptions = res.data
                this.drugoptionsloading = false
            })
        },
        // 选择药品
        drugChange(e) {
            this.drugoptions.forEach(item => {
                if (e == item.title) {
                    this.drugListAddFrom = {
                        info_title: item.title,
                        number: item.number,
                        drugs_dosage_form: item.dosage_form,
                        drugs_specs: item.specs,
                        category_id: this.radioValue,
                        logo: '',
                        banner: '',
                    }
                }
            })
        },
        // 药品删除
        DelDetailsFun(e) {
            let that = this
            this.$confirm(`是否删除 ${e.category_name} 分类下的${e.title} 药品`, '删除药品', {
                distinguishCancelAndClose: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                drugListDel({ id: e.info_id }).then(res => {
                    this.$message({
                        type: 'success',
                        message: res.msg
                    });
                    that.classList()
                })
            }).catch(action => {
                this.$message({
                    type: 'success',
                    message: '您已取消删除！'
                });
            });

        },
        // 点击编辑按钮
        editDetailsFun(e) {
            let from = this.drugListAddFrom
            this.drugtitle = '编辑药品'
            this.showdrugListAdd = true
            this.info_title = e.info_title
            from.number = e.number
            from.drugs_dosage_form = e.dosage_form
            from.drugs_specs = e.specs
            this.drug_description = e.drug_description
            from.category_id = e.category_id
            from.id = e.info_id
            from.logo = e.logo
            let arr = e.banner.split(",")
            let arr2 = []
            arr.forEach((item, index) => {
                if (item !== '') {
                    arr2.push({
                        name: String(index),
                        url: item
                    })
                }

            })
            this.fileList = arr2
            let detail = JSON.parse(e.detail)
            let obj = []
            for (const key in detail) {
                obj.push({
                    key: key,
                    value: detail[key]
                })
            }
            this.JsonData = obj
        },
        // 取消clone
        showdrugListAddFun() {
            this.editAndAdd = false
            this.showdrugListAdd = false
            this.drugListAddFrom = {}
            this.info_title = ''
            this.JsonData = [{
                key: '',
                value: ''
            }]
            this.drug_description = ''
            this.fileList = []
        },
        // 提交banner成功
        fileListSuccess(e) {
            let banner = this.drugListAddFrom.banner
            if (banner == '') {
                this.drugListAddFrom.banner = String(e.data[0])
            } else {
                this.drugListAddFrom.banner = this.drugListAddFrom.banner + ',' + String(e.data[0])
            }
        },
        // banner删除
        fileremove(e) {
            let banner = this.drugListAddFrom.banner
            if (banner.indexOf(',') == -1) {
                this.drugListAddFrom.banner = ''
            } else {
                var arr = this.drugListAddFrom.banner.split(",");
                arr.forEach((item, index) => {
                    if (item == e.response.data[0]) {
                        arr.splice(index, 1)
                    }
                })
                this.drugListAddFrom.banner = arr.join(',')
            }
        },
        InputEvent(e) {
            this.drugListAddFrom.drug_description = this.drug_description
        }
    }
}
</script>

<style >
.ypglBody {
    height: 100%;
}

.ypglMain {
    margin-top: 10px;
    height: calc(100vh - 145px);
}

.asidsStyle {
    border-right: 1px dashed #ccc;
}

.radioBox {
    display: flex;
    flex-direction: column;
    align-items: baseline;
}

.radioStyle {
    width: 85%;
    margin-bottom: 5px;
}

.elMainStyle {
    border-top: 1px dashed #ccc;
}

.drugListAddFromStyle {
    height: 60vh;
    overflow: auto;
}

.titleStyle {}

.detailBox {
    display: flex;

}

.detailBox_left {
    /* display: flex; */
    width: 90%;
}

.detailBox_right {
    width: 10%;
    text-align: end;
    cursor: pointer;
}

.inputStyle1 {
    width: 35%;
    margin-right: 20px;
}

.inputStyle2 {
    width: 48%;
    margin-right: 10px;
}

>>>.el-select {
    width: 89% !important;
}

.cursor {
    cursor: pointer !important;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
</style>


// WEBPACK FOOTER //
// src/views/ypgl/index.vue